import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetApplicationInformation = createAsyncThunk(
  "ApplicationInformation/GetApplicationInformation",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AI_NT_AI_ApplicationInformation/GetOneAI_NT_AI_ApplicationInformation",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AddApplication = createAsyncThunk(
  "AddApplicationInfo/AddApplication",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AI_NT_AI_ApplicationInformation/AddApplicationInformation",
        parameters,
        {
          headers: {
            Authorization: `${sessionStorage.getItem("AccessToken")}`,
          },
        }
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const SubmitApplication = createAsyncThunk(
  "SubmitApplication/SubmitApplication",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AI_NT_AI_ApplicationInformation/SubmitApplication",
        parameters
      );

      const data = response.data.result;
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetAllApplicationByUserGuid = createAsyncThunk(
  "GetAllApplicationByUserGuid/GetAllApplicationByUserGuid",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AI_NT_AI_ApplicationInformation/GetAllApplicationByUserGuid",
        parameters
      );

      const data = response.data.result;
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetApplicationByRound = createAsyncThunk(
  "AI_NT_AI_ApplicationInformation/GetApplicationByRound",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AI_NT_AI_ApplicationInformation/GetApplicationByRound",
        parameters,
        
      );

      const data = response.data.result;
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetActiveRound = createAsyncThunk(
  "Round/GetApplicationByRound",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient("application/json");
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Round/GetActiveRound",
        parameters,
        
      );

      const data = response.data.result;
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetActiveRoundRemaining = createAsyncThunk(
  "Round/GetActiveRoundRemaining",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient("application/json");
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Round/GetRemainingRound",
        parameters
      );

      const data = response.data.result;
      console.log(data,"Qasem");
      
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const ApplicationInformation = createSlice({
  name: "ApplicationInformation",
  initialState: {
    //------------- GetOneApplication ---------------------
    ApplicationInformation: {},
    loadingApplicationInformation: false,
    errorApplicationInformation: null,
    //------------- AddApplication ---------------------
    AddApplication: "",
    loadingAddApplication: false,
    errorAddApplication: null,
    //------------- Submit ---------------------
    SubmitApplication: {},
    loadingSubmitApplication: false,
    errorSubmitApplication: null,

    //------------- AllApplicationByUserGuid ---------------------
    AllApplicationByUserGuid: {},
    loadingAllApplicationByUserGuid: false,
    errorAllApplicationByUserGuid: null,

    //------------- ApplicationByRound ---------------------
    ApplicationByRound: false,
    loadingApplicationByRound: false,
    errorApplicationByRound: null,
    //------------- ActiveRound ---------------------
    ActiveRound: false,
    loadingActiveRound: false,
    errorActiveRound: null,
    //------------- ActiveRoundRemaining ---------------------
    ActiveRoundRemaining: {},
    loadingActiveRoundRemaining: false,
    errorActiveRoundRemaining: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetApplicationInformation.pending, (state, action) => {
        console.log(action.payload, "action.payload");

        state.loadingApplicationInformation = true;
        state.ApplicationInformation = action.payload;
        state.errorApplicationInformation = null;
      })
      .addCase(GetApplicationInformation.fulfilled, (state, action) => {
        state.loadingApplicationInformation = false;
        state.ApplicationInformation = action.payload;
      })
      .addCase(GetApplicationInformation.rejected, (state, action) => {
        state.loadingApplicationInformation = false;
        state.ApplicationInformation = action.payload;
      });
    //------------------- AddApplication -----------------------------------
    builder
      .addCase(AddApplication.pending, (state, action) => {
        state.loadingAddApplication = true;
        state.AddApplication = action.payload;
        state.errorAddApplication = null;
      })
      .addCase(AddApplication.fulfilled, (state, action) => {
        state.loadingAddApplication = false;
        state.AddApplication = action.payload;
      })
      .addCase(AddApplication.rejected, (state, action) => {
        state.loadingAddApplication = false;
        state.errorAddApplication = action.payload;
      });

    builder
      .addCase(SubmitApplication.pending, (state, action) => {
        state.loadingSubmitApplication = true;
        state.SubmitApplication = action.payload;
        state.loadingSubmitApplication = null;
      })
      .addCase(SubmitApplication.fulfilled, (state, action) => {
        state.loadingSubmitApplication = false;
        state.SubmitApplication = action.payload;
      })
      .addCase(SubmitApplication.rejected, (state, action) => {
        state.loadingSubmitApplication = false;
        state.loadingSubmitApplication = action.payload;
      });

    //------------------- GetAllApplicationByUserGuid -----------------------------------
    builder
      .addCase(GetAllApplicationByUserGuid.pending, (state, action) => {
        state.loadingAllApplicationByUserGuid = true;
        state.AllApplicationByUserGuid = action.payload;
        state.errorAgreeTerms = null;
      })
      .addCase(GetAllApplicationByUserGuid.fulfilled, (state, action) => {
        state.loadingAllApplicationByUserGuid = false;
        state.AllApplicationByUserGuid = action.payload;
      })
      .addCase(GetAllApplicationByUserGuid.rejected, (state, action) => {
        state.loadingAllApplicationByUserGuid = false;
        state.errorAllApplicationByUserGuid = action.payload;
      });

    //------------------- GetApplicationByRound -----------------------------------
    builder
      .addCase(GetApplicationByRound.pending, (state, action) => {
        state.loadingApplicationByRound = true;
        state.ApplicationByRound = action.payload;
        state.errorAgreeTerms = null;
      })
      .addCase(GetApplicationByRound.fulfilled, (state, action) => {
        state.loadingApplicationByRound = false;
        state.ApplicationByRound = action.payload;
      })
      .addCase(GetApplicationByRound.rejected, (state, action) => {
        state.loadingApplicationByRound = false;
        state.errorApplicationByRound = action.payload;
      });

    //------------------- GetActiveRound -----------------------------------
    builder
      .addCase(GetActiveRound.pending, (state, action) => {
        state.loadingActiveRound = true;
        state.ActiveRound = action.payload;
        state.errorAgreeTerms = null;
      })
      .addCase(GetActiveRound.fulfilled, (state, action) => {
        state.loadingActiveRound = false;
        state.ActiveRound = action.payload;
      })
      .addCase(GetActiveRound.rejected, (state, action) => {
        state.loadingActiveRound = false;
        state.errorActiveRound = action.payload;
      });
    //------------------- GetActiveRoundRemaining -----------------------------------
    builder
      .addCase(GetActiveRoundRemaining.pending, (state, action) => {
        state.loadingActiveRoundRemaining = true;
        state.ActiveRoundRemaining = action.payload;
        state.errorActiveRoundRemaining = null;
      })
      .addCase(GetActiveRoundRemaining.fulfilled, (state, action) => {
        state.loadingActiveRoundRemaining = false;
        state.ActiveRoundRemaining = action.payload;
      })
      .addCase(GetActiveRoundRemaining.rejected, (state, action) => {
        state.loadingActiveRoundRemaining = false;
        state.errorActiveRoundRemaining = action.payload;
      });
  },
});

export default ApplicationInformation.reducer;
